import * as React from 'react';

function SVGEnergyElectricIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8865 10.5799L15.8416 11.6479L10.523 16.9829L11.1136 13.2479L8.15845 12.1809L13.4771 7.37891L12.8865 10.5799Z"
        stroke="#242938"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="3.35645"
        y="3.53809"
        width="17.2872"
        height="17.2872"
        rx="5"
        stroke="#242938"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export const EnergyElectricIcon = React.memo(SVGEnergyElectricIcon);
